import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * DEV-483 — a tela só de leitura do currículo (DEV-277) deixou de existir:
 * links salvos caem no fluxo de montagem pelo perfil.
 */
export const Route = createFileRoute('/perfil/editar/adicionar-curriculo')({
  beforeLoad: () => {
    throw redirect({ to: '/perfil/curriculo', replace: true });
  },
});
